import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ycrAction } from '../../../../store/actions/admin/ycrAction'
import { Checkbox } from '../../../../components/ui/checkbox'
import DataTableColumnHeader from '../../../../components/table-components/data-table-column-header'
import { DataTableNew } from '../../../../components/table-components/data-table'
import { Link } from 'react-router-dom'
import YcrAssetContent from './YcrAssetContent'
import { Card } from '../../../../components/ui/Card'
import { Button } from '../../../../components/ui/button'
import { components } from "react-select"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../../components/ui/dropdown'
import { DotsHorizontalIcon, Pencil2Icon } from '@radix-ui/react-icons'
import { countryAction } from '../../../../store/actions/countryAction'
import YcrModel from './models/YcrModel'
const YcrContent = () => {
  const dispatch = useDispatch()
  const { ycrData, isLoading, metaData, countries } = useSelector(state => state)
  const [fetchData, setFetchData] = useState(null)
  const [currentPages, setCurrentPages] = useState(null)
  const [perPage, setPerPage] = useState(null)
  const [activeSelect, setActiveSelect] = useState([])
  const [indexOfLastItem, setIndexOfLastItem] = useState(null)
  const [indexOfFirstItem, setIndexOfFirstItem] = useState(null)
  const [editData, setEditData] = useState(null)
  const [openModel, setOpenModel] = useState(false)
  const [firstTime, setFirstTime] = useState(true)


  useEffect(() => {
    dispatch(countryAction())
    setFirstTime(false)
  }, [])

  const countriesAccept = [
    'India',
    'United Kingdom',
    'United States',
    'Japan',
    "Germany",
    'European Union',
  ]


  const allCountries = countries && countries.length ? [{ label: 'All', value: "all" }, ...countries.sort((a, b) => a.countryName.localeCompare(b.countryName)).filter((item) => countriesAccept.includes(item.countryName)).map((item) => {
    return { label: item.countryName, value: item._id }
  })] : []


  useEffect(() => {
    if (activeSelect?.length > 0 && activeSelect) {
      const filterData = {
        page: currentPages,
        perPage: perPage,
        countryIds: activeSelect
      }
      dispatch(ycrAction(filterData)).then((res) => {

        if (res?.data?.success) {
          setFetchData(null)
        }
      })
    }
  }, [activeSelect?.length])

  const onChange = (filter) => {
    setCurrentPages(filter?.page)
    setPerPage(filter?.perPage)
    const filterData = {
      ...filter,
      countryIds: activeSelect
    }
    dispatch(ycrAction(filterData))
  }

  useEffect(() => {
    if (countries && countries.length > 0) {
      const filterCountries = countries && countries?.filter((country) => {
        return countriesAccept.includes(country.countryName)
      });

      const countriesIds = filterCountries?.length > 0 && filterCountries?.map((country) => country?._id)
      setActiveSelect(countriesIds)
    }
  }, [])

  const handleRowSelected = (data) => {
    setFetchData(data)
  }

  useEffect(() => {
    if (currentPages && metaData?.pageSize) {
      setIndexOfLastItem(currentPages * metaData.pageSize);
      setIndexOfFirstItem((currentPages * metaData.pageSize) - metaData.pageSize);
    }
  }, [currentPages, metaData])

  const data = ycrData && ycrData?.records?.length ? ycrData?.records?.map((items, index) => {
    return {
      indexNum: indexOfFirstItem + index + 1,
      id: items._id,
      type: items.type,
      url: items.URL,
      createdAt: items.createdAt,
      updatedAt: items.updatedAt,
      countryName: items.country.countryName,
      countryId: items.country._id
    }
  }) : []

  const columns = [
    {
      id: 'select',
      header:() => (<div className='hidden'></div>),
      cell: ({ row }) => (
        <Checkbox
          checked={row.original?.id === fetchData?.id}
          onCheckedChange={(value) => { row.toggleSelected(!!value); handleRowSelected(row?.original) }}
          aria-label="Select row"
          className="translate-y-[2px] border-black rounded-[4px]"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "indexNum",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return <span className='flex items-center'>{row?.original?.indexNum}</span>
      },
      enableSorting: true,
    },
    {
      accessorKey: "type",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Curve" />
      ),
      cell: ({ row }) => {
        return <span className='flex items-center'>{row?.original?.type}</span>
      },
      enableSorting: true,
    },
    {
      accessorKey: "countryName",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Country Name" />
      ),
      cell: ({ row }) => {
        return <span className='flex items-center'>{row?.original?.countryName}</span>
      },
      enableSorting: true,
    },


    {
      accessorKey: "url",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="URL" />
      ),
      cell: ({ row }) => {
        return <span className='flex items-center line-clamp-1'>
          <Link className='text-blue-400 line-clamp-1' to={row?.original?.url}>{row?.original?.url}</Link>
        </span>
      },
      enableSorting: true,
    },
    {
      id: "actions",
      enableHiding: false,
      header: <span className="flex items-center justify-center">Action</span>,
      cell: ({ row }) => {
        return (
          <div className="flex items-center justify-center">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="p-0">
                  <span className="sr-only">Open menu</span>
                  <DotsHorizontalIcon strokeWidth={"2.2"} className="h-5 w-5 text-textV2" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="center" >
                <DropdownMenuItem className={`text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2`} onClick={() => {
                  setEditData(row?.original);
                  setOpenModel(true);
                }}> <span className='w-5 h-5 bg-themeV2/10 flex items-center justify-center rounded-[4px]'><Pencil2Icon strokeWidth={"2.2"} className='text-themeV2 w-4 h-4' /> </span> Edit </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )
      },
    }
  ];


  const OptionCustomField = ({ children, ...props }) => {
    const { onCheckedCustomFieldBox } = props.selectProps;
    //props?.data?.value === "all" && !checkedData?.includes("all") && assetOptions?.length - 1 === checkedData?.length ? true :
    const checkedCondition = props?.data?.value === "all" && !activeSelect?.includes("all") && allCountries?.length - 1 === activeSelect?.length ? true : activeSelect?.includes(props.data.value)

    return (
      <components.Control {...props}>
        <div className="flex p-2 align-middle justify-start items-center text-sm w-full" onClick={() => onCheckedCustomFieldBox(props)}>
          <span className="me-2">
            <Checkbox
              checked={checkedCondition}
              aria-label="Select row"
              // rounded-[4px]
              className="translate-y-[2px] rounded-[4px] border-black " />
          </span>
          {children}
        </div>
      </components.Control>
    );
  };

  const onCheckedCustomFieldBox = (props) => {
    const { data } = props;
    if (data.value === 'all') {
      if (activeSelect?.length === allCountries?.length - 1) {
        setActiveSelect([])
      } else {
        const assetIds = allCountries?.filter((option) => option?.value !== "all");
        setActiveSelect(() => assetIds?.map((option) => option?.value))
      }
    } else {
      setActiveSelect((prev) => {
        let newData;

        const alreadyExists = prev.some(item => item === data.value);

        if (alreadyExists) {
          const alreadyExistsData = prev.filter(item => item !== data.value);
          newData = alreadyExistsData
        } else {
          newData = allCountries?.value !== null ? [...prev, data?.value] : [data?.value];
        }
        return newData?.filter((aed) => aed !== "all")

      })
    }
  };

  const handleSelectChange = (e) => {
    const parseValue = JSON.parse(e)
    setActiveSelect(parseValue)
  }

  const showNamesOfCountries = () => {
    let names = ""
    allCountries?.length > 0 && allCountries?.map((country) => {
      if (activeSelect?.includes(country?.value)) {
        names += country?.label + ', '
      }
    })
    return names
  }
  const selectOptions = [
    {
      name: "Country",
      text: "Country :",
      onChange: (e) => handleSelectChange(e),
      components: OptionCustomField,
      isDisabled: false,
      className: "",
      placeholder: activeSelect?.length > 0 ? showNamesOfCountries() : "Select country :",
      options: allCountries,
      onCheckedCustomFieldBox,
    }
  ]

  return (
    <>
      <Card className='my-0 md:my-0 md:p-0 p-0 bg-white !mb-3'>
        <div className="main-table-wrapper">
          <div className={`p-3 md:p-5 `}>
            <DataTableNew data={data} columns={columns} loadData={isLoading} isLeftSelect={true} leftSelectOptions={selectOptions} isCollViewHide={true} onChange={onChange} filterName={'type'} isSearchHide={true}  />
          </div>
          <YcrModel show={openModel} onHide={setOpenModel} data={editData} />
        </div>
      </Card>

      {fetchData?.id ? <Card className='my-0 md:my-0 md:p-0 p-0 bg-white !mt-3'>
        <div className="main-table-wrapper">
          <div className={`p-3 md:p-5 `}>
            <YcrAssetContent fetchData={fetchData} countries={activeSelect}  />
          </div>
        </div>
      </Card> : ''}
    </>
  )
}

export default YcrContent
